<script setup lang="ts">
import { NuxtLink } from '#components';

import { currentYear } from '@/shared/lib/temporal';

import { FOOTER_LINKS } from '../config/navigation';
</script>

<template>
  <footer>
    <div class="container flex-between text-sm">
      <div class="logo-block">
        <img
          class="logo"
          src="/icons/lesta-logo.svg"
          alt="lesta-logo"
          loading="lazy"
        />

        <div class="description flex-col">
          <p>
            Игра «Мир кораблей» основана на&nbsp;интеллектуальной собственности третьих лиц. Все
            права на&nbsp;объекты прав третьих лиц принадлежат их&nbsp;законным правообладателям.
          </p>
          <p>&copy;&nbsp;Леста Игры, 2022 – {{ currentYear }}</p>
        </div>
      </div>

      <div class="link-list">
        <component
          :is="item.isExternal ? 'a' : NuxtLink"
          v-for="(item, index) in FOOTER_LINKS"
          :key="index"
          v-bind="item.isExternal ? { href: item.link, target: '_blank' } : { to: item.link }"
          class="link xs"
        >
          {{ item.name }}
        </component>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="postcss">
footer {
  --spacing: var(--space-m-var_03);

  padding-top: var(--space-xl-var_01);
  padding-bottom: var(--spacing);
  color: var(--color-white-50);

  & .container {
    position: relative;
    padding-top: var(--spacing);
    border-top: 1px solid var(--color-white-12);
  }
}

.description {
  display: flex;

  gap: var(--space-s-var_01);
  max-width: 560px;
  text-wrap: pretty;

  @media (--lg-desktop) {
    max-width: 710px;
  }
}

.logo-block {
  display: grid;
  grid-template-columns: 146px auto;
  gap: var(--space-m-var_02);

  .logo {
    position: relative;
    top: -8px;
    width: 100%;
  }
}

.link-list {
  display: grid;
  grid-template: auto / 1fr auto;
  align-items: flex-start;
  gap: var(--space-m-var_02) var(--space-xl-var_01);

  a {
    justify-self: baseline;
  }
}
</style>
